import { SVGProps } from 'react';

interface LabelRibonMobileType extends SVGProps<SVGSVGElement> {
  textColor?: string;
  stopColorOne?: string;
  stopColorTwo?: string;
}

const LabelRibonMobile = ({
  width = 34,
  height = 14,
  className,
  textColor = '#101013',
  stopColorOne = '#FFE633',
  stopColorTwo = '#FCCB18',
}: LabelRibonMobileType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    className={className}
    data-palette="LabelRibonMobile">
    <rect width={34} height={14} fill="url(#a)" rx={2} />
    <g clipPath="url(#b)">
      <path
        fill="#000"
        d="M26.25 6.75a2.5 2.5 0 0 0 2.5-2.5h.5a2.5 2.5 0 0 0 2.5 2.5v.5a2.5 2.5 0 0 0-2.5 2.5h-.5a2.5 2.5 0 0 0-2.5-2.5v-.5Z"
      />
    </g>
    <path
      fill={textColor}
      d="M10.65 10H9.07L6.01 4.31c.03.79.04 1.68.04 2.39V10h-1.1V3.1H6.5l3.09 5.73c-.02-.78-.03-1.7-.03-2.41V3.1h1.08l.01 6.9Zm5.983-2.79c0 .1 0 .25-.02.44h-3.81c.09 1.27.67 1.69 1.39 1.69.64 0 1.14-.39 1.25-1.06h1.11c-.23 1.26-1.24 1.86-2.4 1.86-1.42 0-2.49-.9-2.49-2.78 0-1.68 1.07-2.81 2.6-2.81 1.54 0 2.37 1.16 2.37 2.66Zm-2.41-1.86c-.75 0-1.29.51-1.41 1.53h2.69c-.08-.98-.51-1.53-1.28-1.53Zm10.795-.66L23.328 10h-1.26l-1.05-4.29-1.06 4.29h-1.27l-1.69-5.31h1.24l1.09 4.33 1.03-4.32h1.34l1.06 4.33 1.09-4.34h1.17Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={-17}
        x2={-7.142}
        y1={7}
        y2={30.941}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={stopColorOne} />
        <stop offset={1} stopColor={stopColorTwo} />
      </linearGradient>
      <clipPath id="b">
        <path fill="#fff" d="M26 4h6v6h-6z" />
      </clipPath>
    </defs>
  </svg>
);
export default LabelRibonMobile;
